import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import RootState from '../../modules/rootState';
import Experian, { StateFromProps, DispatchFromProps, OwnProps } from './Experian';
import { ConfirmIndentityRequest } from 'src/models/question';
import * as experianQuestionData from 'src/modules/entities/experianQuestion';
import * as workflowData from 'src/modules/entities/workflow';
import Workflow from 'src/models/workflow';

const mapStateToProps = (rootState: RootState, props: OwnProps): StateFromProps => ({
    registrationId: workflowData.selectors.getRegistrationId(rootState),
    sessionId: workflowData.selectors.getSessionId(rootState),
    questions: experianQuestionData.selectors.getExperianQuestion(rootState),

    submitting: experianQuestionData.selectors.submitting(rootState),
    submitted: experianQuestionData.selectors.submitted(rootState),
    isPass: experianQuestionData.selectors.isPass(rootState),

    workflow: workflowData.selectors.getWorkflow(rootState),
    checkRetry: workflowData.selectors.checkRetry(rootState),
    // errorMessage: experianQuestionData.selectors.getErrorMessage(rootState)
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
    submitExperianAnswers: (confirmIdentityAnswer: ConfirmIndentityRequest): void => {
        dispatch(experianQuestionData.actions.submitExperianAnswersAsync(confirmIdentityAnswer));
    },
    updateWorkflow: (workflow: Workflow): void => {
        dispatch(workflowData.actions.storeWorkflowData(workflow));
    },
    submitExperianQuestions: (confirmIdentityAnswer: ConfirmIndentityRequest): void => {
        dispatch(experianQuestionData.actions.submitExperianQuestionsAsync(confirmIdentityAnswer));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Experian);


// WEBPACK FOOTER //
// ./src/components/Experian/Experian.container.ts